// src/components/ui/TabBar.jsx
import React from 'react';
import { SafeIcon } from '../../contexts/nobishiro-dashboard/SVGErrorBoundary';

const TabBar = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="mb-6 sticky top-2 z-10 bg-gray-50/80 backdrop-blur-sm py-2 rounded-xl">
      <div className="flex space-x-1 bg-white p-1.5 rounded-xl shadow-sm border border-gray-200 overflow-x-auto scrollbar-hide">
        {tabs.map(tab => ( 
          <button 
            key={tab.id} 
            onClick={() => setActiveTab(tab.id)} 
            className={`relative flex-shrink-0 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg text-sm font-semibold transition-all duration-200 ease-in-out ${
              activeTab === tab.id 
                ? 'bg-blue-600 text-white shadow-lg scale-105' 
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
            }`}
          >
            <SafeIcon IconComponent={tab.Icon} className="w-5 h-5" /> 
            <span className="hidden sm:inline">{tab.label}</span> 
            {tab.badge && (
              <span className={`absolute -top-1 -right-1 ${
                tab.badge === 'AI' ? 'bg-yellow-500' : 
                tab.badge === 'NEW' ? 'bg-green-500' : 'bg-red-500'
              } text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold shadow-md`}>
                {tab.badge}
              </span>
            )} 
          </button> 
        ))}
      </div>
    </div>
  );
};

export default TabBar;